












































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import CapableAppModal from './CapableAppModal.vue';
import ContentHighlightsEditModal from '../contentHighlights/ContentHighlightsEditModal.vue';
import { appsApi } from '@/features/apps/shared/services/apps';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { InstalledApp } from '@/features/apps/shared/models';
import { ConfigRequest } from './configRequest';
import { ConfiguredAppIntegration } from '@/features/apps/shared/models/configuredAppIntegration';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import EditIcon from 'vue-material-design-icons/SquareEditOutline.vue';
// @ts-ignore
import draggable from 'vuedraggable';

@Component({
	components: {
		CapableAppModal,
		draggable,
		AddIcon,
		EditIcon,
		ContentHighlightsEditModal
	}
})
export default class CapableAppPicker extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Prop() public capability: string;
	@Prop() public selectedApps: ConfiguredAppIntegration[];
	@Prop() public configRequest: ConfigRequest;
	@Prop() public modalHeading: string;
	@Prop({default: false}) public isLozengeMode: boolean;

	public capableApps: InstalledApp[] = [];
	public showModal = false;
	public showAppEditModal = false;
	public editingAppIndex?: number;

	public apps: ConfiguredAppIntegration[] = [];

	@Watch('selectedApps', { immediate: true })
	public onSelectedAppsChanged(value: ConfiguredAppIntegration[]) {
		this.apps = value;
	}

	public mounted() {
		appsApi.getCapableApps(this.currentWorkspace.id, [this.capability])
			.then(apps => {
				this.capableApps = apps.map(app => app as InstalledApp);
			});
	}

	public appAdded(installedAppId: string, config: any) {
		this.apps.push({ installedAppId, config });
		this.emitChangeEvent();
	}

	public appRemoved(index: number) {
		this.apps.splice(index, 1);
		this.emitChangeEvent();
	}

	public appsMoved(e: DraggableChangeEvent) {
		if (e.moved) {
			this.emitChangeEvent();
		}
	}

	public getName(installedAppId: string) {
		return this.getCapableApp(installedAppId).name;
	}

	public getDescription(installedAppId: string) {
		return this.getCapableApp(installedAppId).description || 'Private app';
	}

	public hasSelectedApps() {
		return this.apps
			&& this.apps.length
			&& this.capableApps
			&& this.capableApps.length;
	}

	public openContentHighlightsEditModal(appIndex: number) {
		this.showAppEditModal = true;
		this.editingAppIndex = appIndex;
	}

	public handleAppSave(app: ConfiguredAppIntegration, appIndex: number) {
		this.$emit('update', app, appIndex);
		this.showAppEditModal = false;
		this.editingAppIndex = undefined;
	}

	public canEditApp(app: ConfiguredAppIntegration): boolean {
		const contentHighlightsApp = this.capableApps.find(a => a.appId === 'contenthighlights');

		if (!contentHighlightsApp) {
			return false;
		}

		if (app.installedAppId !== contentHighlightsApp.installedAppId) {
			return false;
		}

		return true;
	}

	private getCapableApp(installedAppId: string) {
		return this.capableApps.find(ca => ca.installedAppId === installedAppId) as InstalledApp;
	}

	private emitChangeEvent() {
		this.$emit('change', this.apps);
	}
}

export interface DraggableChangeEvent {
	moved: {
		newIndex: number,
		oldIndex: number,
		element: Element
	};
}

